import { ITrainerSchedule } from 'app/shared/Domains/trainerSchedule';
import { ISkills } from "./skills";

export class ITrainer {
    _id: string;
    name: string;
    profile: string;
    gender: string;
    totalFees: string;
    contact: string;
    isDelete: boolean;
    gymShare: string;
    trainerShare: string;
    // from: Date;
    // to: Date;
    cardNo: string;
    branch: string;
    company: string;
    createdBy: string;
    createdDate: Date;
    modifiedBy: string;
    modifiedDate: Date;
    selectedSkills:ISkills[];
    timeSchedule:ITrainerSchedule[];
    trainerCode: string;
    userCode: any;
    role: string;


}
